export default __webpack_public_path__ + "static/media/Landing Page - Middle Placeholder Image (4975x2767px).d3ca5ecb.png";